"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchHotelContracts = void 0;
const dayjs = require("dayjs");
const fetchHotelContracts = async (supabase, check_in_date, number_of_nights, hotel_id) => {
    const start_date = check_in_date;
    const end_date = dayjs(check_in_date)
        .add(number_of_nights > 1 ? number_of_nights : 0, "days")
        .format("YYYY-MM-DD");
    const start = dayjs(start_date).startOf("day").toDate();
    const end = dayjs(end_date).startOf("day").toDate();
    const { data: initialData, error } = await supabase
        .from("hotel_contracts")
        .select(`*,       
            blackout_dates:hotel_contract_blackout_dates(*),
            hotel:hotel_id (id, name), 
            supplier:supplier_id (id, name, currency), 
            hotel_contract_notes(count),
            products:hotel_contract_products(
              *,
              hotel_room:hotel_rooms!hotel_room_id(id, name, view, room_size, max_occupancy, bed_options, images, description, amenities),
              rates:hotel_contract_product_rates(
                *
              )
            )`)
        .eq("hotel_id", hotel_id);
    // filter the above so that only hotel contracts which
    if (error) {
        return [];
    }
    if (!initialData) {
        return [];
    }
    // filter the contracts to only contain contracts that are active for the given date range
    const data = initialData.filter((contract) => {
        const contract_start = dayjs(contract.start_date).startOf("day").toDate();
        const contract_end = dayjs(contract.end_date).startOf("day").toDate();
        return ((contract_start <= start && contract_end >= start) ||
            (contract_start <= end && contract_end >= end) || // if the contract wraps around the start or end date
            (contract_start >= start && contract_end <= end) // or if the contract is completely within the start and end date
        );
    });
    // within each contract, filter the contract.date_bands to only contain bands that wrap around either the start or the end date
    data.forEach((contract) => {
        const bands = contract.price_bands.filter((band) => {
            const band_start = dayjs(band.from_date).startOf("day").toDate();
            const band_end = dayjs(band.to_date).startOf("day").toDate();
            return ((band_start <= start && band_end >= start) ||
                (band_start <= end && band_end >= end) || // if the band wraps around the start or end date
                (band_start >= start && band_end <= end) // or if the band is completely within the start and end date
            );
        });
        contract.price_bands = bands;
        contract.products.forEach((product) => {
            const rates = product.rates.map((rate) => {
                const cancellation_policy = contract.cancellation_policies
                    ? contract.cancellation_policies.find((policy) => policy.id === rate.cancellation_penalty_id)
                    : null;
                const discount = contract.discounts
                    ? contract.discounts.find((discount) => discount.id === rate.discount_id)
                    : null;
                return {
                    ...rate,
                    cancellation_policy: cancellation_policy,
                    discount: discount,
                };
            });
            product.rates = rates;
        });
    });
    return data;
};
exports.fetchHotelContracts = fetchHotelContracts;
